import { isClient } from "utils/index";
import AccountActionTypes from "./types";

let cookiesPkg = null;
if (isClient()) {
    cookiesPkg = require("js-cookie");
}

export const updateUserTaxDataTransitions = (transitions) => ({
    type: AccountActionTypes.UPDATE_USER_TAX_DATA_TRANSITIONS,
    payload: transitions,
});

export const updateUserTaxDataStart = (taxData) => ({
    type: AccountActionTypes.UPDATE_USER_TAX_DATA_START,
    taxData,
});

export const updateUserData = (userData) => ({
    type: AccountActionTypes.UPDATE_USER_DATA,
    payload: userData,
});

export const setCanMakeCall = (payload) => ({
    type: AccountActionTypes.SET_CAN_MAKE_CALL,
    payload,
});

export const setOnboardingProcessStatus = (status) => ({
    type: AccountActionTypes.SET_ONBOARDING_PROCESS_STATUS,
    payload: status,
});

export const setUserRegistrationOnboardingStatus = (status) => ({
    type: AccountActionTypes.SET_USER_REGISTRATION_ON_BOARDING_STATUS,
    payload: status,
});

export const updateUserDataField = (route, value) => ({
    type: AccountActionTypes.UPDATE_USER_DETAIL_FIELD,
    payload: { route, value },
});

export const setTipsterPdfDownloaded = (isTipsterPdfDownloaded) => ({
    type: AccountActionTypes.SET_TIPSTER_PDF_DOWNLOADED,
    payload: isTipsterPdfDownloaded,
});

export const setOnboardingProcessData = (data) => ({
    type: AccountActionTypes.SET_ONBOARDING_PROCESS_STEP_DATA,
    payload: data,
});

export const setTipsterData = (payload) => ({
    type: AccountActionTypes.SET_TIPSTER_DATA,
    payload,
});

export const fetchUserAllDetailsStart = (payload) => ({
    type: AccountActionTypes.FETCH_ALL_USER_DETAILS_START,
    isGetInheritUserKyc: payload,
});

export const fetchUserAllDetailsSuccess = () => ({
    type: AccountActionTypes.FETCH_ALL_USER_DETAILS_SUCCESS,
});
export const fetchUserAllDetailsFailure = () => ({
    type: AccountActionTypes.FETCH_ALL_USER_DETAILS_FAILURE,
});

export const fetchUserDetailsStart = () => ({
    type: AccountActionTypes.FETCH_USER_DETAILS_START,
});
export const fetchUserDetailsSuccess = (userData) => ({
    type: AccountActionTypes.FETCH_USER_DETAILS_SUCCESS,
    payload: userData,
});
export const fetchUserDetailsFailure = (error) => ({
    type: AccountActionTypes.FETCH_USER_DETAILS_FAILURE,
    payload: error,
});

export const setUserMobileData = (payload) => ({
    type: AccountActionTypes.SET_USER_MOBILE_DATA,
    payload,
});

export const setUserMobileDetailsStart = (mobileDetails) => ({
    type: AccountActionTypes.SET_USER_MOBILE_DETAILS_START,
    payload: mobileDetails,
});
export const setUserMobileDetailsSuccess = (mobileDetails) => ({
    type: AccountActionTypes.SET_USER_MOBILE_DETAILS_SUCCESS,
    payload: mobileDetails,
});
export const setUserMobileDetailsFailure = (error) => ({
    type: AccountActionTypes.SET_USER_MOBILE_DETAILS_FAILURE,
    payload: error,
});

export const storeAuthTokenData = (accessToken) => {
    return {
        type: AccountActionTypes.SET_AUTH_TOKEN_DATA,
        payload: accessToken,
    };
};

export const logout = () => {
    clearAllAuthCookie();
    return {
        type: AccountActionTypes.LOGOUT,
    };
};

export const userDashboardDetailsStart = () => ({
    type: AccountActionTypes.USER_DASHBOARD_DETAILS_START,
});

export const userDashboardDetailsSuccess = (dashboardData) => ({
    type: AccountActionTypes.USER_DASHBOARD_DETAILS_SUCCESS,
    payload: dashboardData,
});
export const userDashboardDetailsFailure = (error) => ({
    type: AccountActionTypes.USER_DASHBOARD_DETAILS_FAILURE,
    payload: error,
});

export function fetchPayInWalletBalanceStart(payload) {
    return {
        type: AccountActionTypes.FETCH_PAY_IN_WALLET_BALANCE_START,
        payload,
    };
}
export function fetchPayInWalletBalanceSuccess(walletBalance) {
    return {
        type: AccountActionTypes.FETCH_PAY_IN_WALLET_BALANCE_SUCCESS,
        payload: walletBalance,
    };
}
export function fetchPayInWalletBalanceFailure(error) {
    return {
        type: AccountActionTypes.FETCH_PAY_IN_WALLET_BALANCE_FAILURE,
        payload: error,
    };
}

export function fetchBlockedWalletBalanceStart(payload) {
    return {
        type: AccountActionTypes.FETCH_BLOCKED_WALLET_BALANCE_START,
        payload,
    };
}
export function fetchBlockedWalletBalanceSuccess(walletBalance) {
    return {
        type: AccountActionTypes.FETCH_BLOCKED_WALLET_BALANCE_SUCCESS,
        payload: walletBalance,
    };
}
export function fetchBlockedWalletBalanceFailure(error) {
    return {
        type: AccountActionTypes.FETCH_BLOCKED_WALLET_BALANCE_FAILURE,
        payload: error,
    };
}

export function fetchUserPaymentsStart(userID) {
    return {
        type: AccountActionTypes.FETCH_PAYMENTS_FOR_USER_START,
        payload: userID,
    };
}
export function fetchUserPaymentsSuccess(payments) {
    return {
        type: AccountActionTypes.FETCH_PAYMENTS_FOR_USER_SUCCESS,
        payload: payments,
    };
}
export function fetchUserPaymentsFailure(error) {
    return {
        type: AccountActionTypes.FETCH_PAYMENTS_FOR_USER_FAILURE,
        payload: error,
    };
}

export function fetchUserMinPayInAmountStart() {
    return {
        type: AccountActionTypes.USER_MIN_PAYIN_AMOUNT_START,
    };
}
export function fetchUserMinPayInAmountSuccess(minPayInAmount) {
    return {
        type: AccountActionTypes.USER_MIN_PAYIN_AMOUNT_SUCCESS,
        payload: minPayInAmount,
    };
}
export function fetchUserMinPayInAmountFailure(error) {
    return {
        type: AccountActionTypes.USER_MIN_PAYIN_AMOUNT_FAILURE,
        payload: error,
    };
}

// Sets a field value
export const setUserFieldValue = (key, value) => ({
    type: AccountActionTypes.SET_USER_FIELD_VALUE,
    payload: { key, value },
});

export const updateUserMangopayKYCLevel = (value) => ({
    type: AccountActionTypes.UPDATE_USER_MANGOPAY_KYC_LEVEL,
    payload: value,
});

export const clearAllAuthCookie = () => {
    if (isClient()) {
        const FINX_COOKIE = require("common/constants");

        localStorage.removeItem(FINX_COOKIE.FINX_ACCESS_TOKEN);
        localStorage.removeItem(FINX_COOKIE.REFRESH_TOKEN);
        localStorage.removeItem(FINX_COOKIE.FINX_SESSION);
        localStorage.removeItem(FINX_COOKIE.IS_USER_INITIAL_LOGIN);
        localStorage.removeItem(FINX_COOKIE.SOCIAL_LOGIN_PROVIDER);

        cookiesPkg.remove(FINX_COOKIE.FINX_SESSION);
        cookiesPkg.remove(FINX_COOKIE.FINX_ACCESS_TOKEN);
        cookiesPkg.remove(FINX_COOKIE.FINX_SESSION, { domain: ".finexity.com" });

        cookiesPkg.remove(FINX_COOKIE.USER_EMAIL);
        cookiesPkg.remove(FINX_COOKIE.USER_ROLE);
        cookiesPkg.remove(FINX_COOKIE.CLUB_DEAL_STATUS);
    }
};

export const exitInheritUser = () => {
    const FINX_COOKIE = require("common/constants");

    cookiesPkg.remove(FINX_COOKIE.INHERIT_USER_TOKEN);
    cookiesPkg.remove(FINX_COOKIE.INHERIT_USER_EMAIL);
    localStorage.removeItem(FINX_COOKIE.INHERIT_USER_TOKEN_EXPIRATION);

    window.location = "/dashboard";
};

export const fetchUserTermsAndConditionSuccess = (termsAndConditions) => ({
    type: AccountActionTypes.FETCH_USER_TERMS_AND_CONDITIONS_SUCCESS,
    payload: termsAndConditions,
});

export const fetchUserSubscriptionsStart = (userID, callback = () => {}) => ({
    type: AccountActionTypes.FETCH_USER_SUBSCRIPTIONS_START,
    userID,
    callback,
});
export const fetchUserSubscriptionsSuccess = (data) => ({
    type: AccountActionTypes.FETCH_USER_SUBSCRIPTIONS_SUCCESS,
    payload: data,
});
export const fetchUserSubscriptionsFailure = (error) => ({
    type: AccountActionTypes.FETCH_USER_SUBSCRIPTIONS_FAILURE,
    payload: error,
});

export const checkSparkasseConnection = () => ({
    type: AccountActionTypes.CHECK_SPARKASSE_CONNECTION,
});

export const setIsSparkasseAccountConnected = (isConnected) => ({
    type: AccountActionTypes.SET_SPARKASSE_ACCOUNT_CONNECTED,
    payload: isConnected,
});

export const setSparkasseUserDetails = (userDetails) => ({
    type: AccountActionTypes.SET_SPARKASSE_USER_DETAILS,
    payload: userDetails,
});

export const disconnectSparkasseAccount = () => ({
    type: AccountActionTypes.DISCONNECT_SPARKASSE_ACCOUNT,
});
